import React, { useEffect, useRef, useState } from 'react';
import { MultipleModal } from '../../../../components/MultipleModal/MultipleModal';
import styles from './RequestsHints.module.scss';
import { RequestsHint } from './components/RequestsHint/RequestsHint';
import { CreateRequestModal } from './components/CreateRequestModal/CreateRequestModal';
import { changeShowHintsAndOldRequests } from './api/changeShowHintsAndOldRequests';
import { HintsByServiceCompanyAndType } from './components/HintsByServiceCompanyAndType/HintsByServiceCompanyAndType';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../CreateRequest/new-request.actions';

export const RequestsHints = ({ visible, onVisible, onClose }) => {
  const {
    showHints,
    showOldRequests,
    valueAddrBuilding: houseId,
    valueSubservice: typeId,
    hintsByServiceCompany,
    hintsByRequestType,
  } = useSelector((state) => state.newRequestStore);

  const { ShowHints, ShowOldRequests } = useSelector(
    (state) => state.authentication.userInfo
  );

  const dispatch = useDispatch();

  const [visibleHintsCheck, setVisibleHintsCheck] = useState(false);
  const [visibleRequestsCheck, setVisibleRequestsCheck] = useState(false);
  const createRequestModalRef = useRef(null);

  const handleCreateRequestModalVisible = () => {
    onClose();
  };

  const handleCloseHints = async (isChecked) => {
    setVisibleHintsCheck(false);

    await changeShowHintsAndOldRequests({
      showOldRequests: visibleRequestsCheck,
      showHints: isChecked,
    });
  };

  const handleCloseRequests = async (isChecked) => {
    setVisibleRequestsCheck(false);

    await changeShowHintsAndOldRequests({
      showOldRequests: isChecked,
      showHints: visibleHintsCheck,
    });
  };

  const handleCheckHints = async (e) => {
    const isChecked = e.target.checked;

    setVisibleHintsCheck(isChecked);

    await changeShowHintsAndOldRequests({
      showOldRequests: visibleRequestsCheck,
      showHints: isChecked,
    });
  };

  const handleCheckRequests = async (e) => {
    const isChecked = e.target.checked;

    setVisibleRequestsCheck(isChecked);

    await changeShowHintsAndOldRequests({
      showOldRequests: isChecked,
      showHints: visibleHintsCheck,
    });
  };

  useEffect(() => {
    const canShowHints = visibleHintsCheck && ShowHints;

    if (canShowHints && houseId) {
      dispatch(actions.fetchHintsByServiceCompany({ houseId }));
    } else {
      dispatch(actions.clearHintsByServiceCompany());
    }

    if (canShowHints && (houseId || typeId)) {
      dispatch(actions.fetchGetHintsByRequestType({ houseId, typeId }));
    } else {
      dispatch(actions.clearHintsByRequestType());
    }
  }, [visibleHintsCheck, ShowHints, houseId, typeId]);

  useEffect(() => {
    if (
      typeof showHints === 'boolean' &&
      typeof showOldRequests === 'boolean'
    ) {
      setVisibleHintsCheck(showHints);
      setVisibleRequestsCheck(showOldRequests);
    }
  }, [showHints, showOldRequests]);

  const handleMultipleClose = async () => {
    if (
      createRequestModalRef.current &&
      typeof createRequestModalRef.current.tryClose === 'function'
    ) {
      const ok = await createRequestModalRef.current.tryClose();
      if (!ok) return;
    }
    onClose();
  };

  return (
    <MultipleModal
      visible={visible}
      onVisible={onVisible}
      onClose={handleMultipleClose}
    >
      <div className={styles.root}>
        <CreateRequestModal
          ref={createRequestModalRef}
          visible={visible}
          canChangeVisibleRequests={ShowOldRequests}
          canChangeVisibleHints={ShowHints}
          visibleHintsCheck={visibleHintsCheck}
          visibleRequestsCheck={visibleRequestsCheck}
          handleCheckHints={handleCheckHints}
          handleCheckRequests={handleCheckRequests}
          setVisible={handleCreateRequestModalVisible}
        />
        {visibleHintsCheck && ShowHints && (
          <div>
            <HintsByServiceCompanyAndType
              hintsByServiceCompany={hintsByServiceCompany}
              hintsByRequestType={hintsByRequestType}
              setVisible={() => handleCloseHints(false)}
            />
          </div>
        )}
        {visibleRequestsCheck && ShowOldRequests && (
          <div>
            <RequestsHint
              canChangeVisibleRequests={ShowOldRequests}
              setVisible={(prev) => handleCloseRequests(!prev)}
              visible={visibleRequestsCheck}
            />
          </div>
        )}
      </div>
    </MultipleModal>
  );
};
